<div class="row">
  <section>
    <div class="row">
      <form [formGroup]="formOptionPrint">
        <div class="ps-2 pe-2 pb-2">
          <div class="row py-2">
            <app-custom-checkbox formControlName="printStore" [labelText]="'Imprimir Bodega'"></app-custom-checkbox>
          </div>
          <div class="row py-2">
            <app-custom-checkbox formControlName="printQuantity"
              [labelText]="'Imprimir Cantidades'"></app-custom-checkbox>
          </div>
        </div>
      </form>
    </div>
  </section>
  <section>
    <div class="d-flex justify-content-end">
      <app-custom-button [title]="'Imprimir'" [label]="'Imprimir'" [severity]="'primary'"
        (onClick)="printPredevolution()"></app-custom-button>
    </div>
  </section>
</div>